import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useBreakpoints } from "@qgiv/core-react";
import ConnectedSaveAndContinue from "./ConnectedSaveAndContinue";
import ConnectedBackButtonSection from "./ConnectedBackButtonSection";
import ConnectedSaveAndAddParticipant from "./ConnectedSaveAndAddParticipant";
import "./Submit.scss";

const Submit = ({ controlId, isCms = false }) => {
    const { setSubmitting, submitForm, setFieldValue } = useFormikContext();
    const { isGreaterThanXLS } = useBreakpoints();

    const handleClick = (e, { addNewRegistration }) => {
        if (isCms) {
            // we do not want to submit anything in cms view
            return;
        }

        setFieldValue("Add_New_Registration", addNewRegistration);
        setSubmitting(true);
        submitForm();
    };

    return (
        <div className="registration-page-submit">
            {/* eslint-disable-next-line tailwindcss/classnames-order */}
            <div className="grid grid--align-items-center -margin-top--30">
                {isGreaterThanXLS ? (
                    <>
                        <ConnectedBackButtonSection controlId={controlId} />

                        <ConnectedSaveAndAddParticipant
                            handleClick={handleClick}
                            controlId={controlId}
                        />

                        <ConnectedSaveAndContinue
                            handleClick={handleClick}
                            controlId={controlId}
                        />
                    </>
                ) : (
                    <>
                        <ConnectedSaveAndAddParticipant
                            handleClick={handleClick}
                            controlId={controlId}
                        />

                        <ConnectedSaveAndContinue
                            handleClick={handleClick}
                            controlId={controlId}
                        />

                        <ConnectedBackButtonSection controlId={controlId} />
                    </>
                )}
            </div>
        </div>
    );
};

Submit.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    // Flag to determine if to display back button
    isCms: PropTypes.bool.isRequired,
};

export default Submit;
